import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import {
  Box,
  Button,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { SendMeetingReminderButton } from "../../../../components/buttons";

function EventTooltipActions({
  zoomURL,
  showSendReminder,
  isScheduledTimeExpired,
  invitationRecordId,
  additionalMembersCount,
  onAddMemberClick,
}: {
  zoomURL?: string;
  showSendReminder: boolean;
  isScheduledTimeExpired: boolean;
  invitationRecordId?: string;
  additionalMembersCount?: number;
  onAddMemberClick: () => void;
}) {
  const showZoomActions = Boolean(zoomURL && !isScheduledTimeExpired);
  return (
    <Box
      sx={{
        px: 2,
        pt: 1.5,
        pb: 2,
        bgcolor: "#FAFBFC",
        borderTop: "1px solid #EEF2F7",
      }}
    >
      <Typography
        fontSize={11}
        fontWeight={700}
        color="#94A3B8"
        letterSpacing={0.7}
        textTransform="uppercase"
        mb={1.25}
      >
        Quick actions
      </Typography>

      <Stack spacing={1.25}>
        {isScheduledTimeExpired && zoomURL && (
          <Box display="flex" alignItems="center" gap={0.75}>
            <WarningAmberOutlinedIcon sx={{ fontSize: 18, color: "#EA580C" }} />
            <Typography
              fontSize={13}
              fontWeight={500}
              color="#EA580C"
              lineHeight={1.4}
            >
              The scheduled time is no longer valid
            </Typography>
          </Box>
        )}

        {showZoomActions && (
          <Button
            fullWidth
            variant="contained"
            disableElevation
            href={zoomURL}
            target="_blank"
            rel="noopener noreferrer"
            startIcon={<VideocamOutlinedIcon sx={{ fontSize: 18 }} />}
            sx={{
              py: 1.1,
              borderRadius: 1.5,
              textTransform: "none",
              fontWeight: 700,
              fontSize: 14,
              bgcolor: "#2563EB",
              "&:hover": { bgcolor: "#1D4ED8" },
            }}
          >
            Join meeting
          </Button>
        )}

        {(showZoomActions || showSendReminder) && (
          <Box
            sx={{
              border: "1px solid #E2E8F0",
              borderRadius: 1.5,
              overflow: "hidden",
              bgcolor: "#FFFFFF",
            }}
          >
            <List disablePadding dense>
              {showZoomActions && (
                <ListItemButton
                  onClick={onAddMemberClick}
                  sx={{
                    py: 1.1,
                    px: 1.5,
                    "&:hover": { bgcolor: "#F8FAFC" },
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <GroupsOutlinedIcon sx={{ fontSize: 20, color: "#475569" }} />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      additionalMembersCount ? "Edit attendees" : "Add attendees"
                    }
                    primaryTypographyProps={{
                      fontSize: 13.5,
                      fontWeight: 600,
                      color: "#0F172A",
                    }}
                  />
                  <ChevronRightRoundedIcon sx={{ fontSize: 20, color: "#CBD5E1" }} />
                </ListItemButton>
              )}
              {showSendReminder && (
                <SendMeetingReminderButton
                  ambassadorInvitationId={invitationRecordId}
                  variant="popover"
                />
              )}
            </List>
          </Box>
        )}
      </Stack>
    </Box>
  );
}

export { EventTooltipActions };
